import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { ExclusionTypeRaw } from '../types/exclusion-types';
import { MdOutlineRemoveCircle as PlaylistRemoveIcon } from 'react-icons/md';
import { ReactComponent as PolicyXIcon } from '../../assets/icons/policyX.svg';
import { ReactComponent as ExclusionsIcon } from '../../assets/icons/exclusions-small.svg';
import { IconType } from 'common-types';
import { FC } from 'react';

export const ActionIconMap = new Map<ExclusionTypeRaw, IconType>([
  [ExclusionTypeRaw.alert, ExclusionsIcon],
  [ExclusionTypeRaw.application, PlaylistRemoveIcon],
  [ExclusionTypeRaw.policy, PolicyXIcon],
]);

const ActionIcon: FC<React.PropsWithChildren<ActionIconProps>> = ({ type }) => {
  const { classes } = useStyles();
  const ActionIcon = ActionIconMap.get(ExclusionTypeRaw[type]) as IconType;

  return (
    <div className={classes.actionIcon}>
      <ActionIcon fontSize='small' />
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  actionIcon: { display: 'flex', color: theme.palette.primary.main },
}));

export interface ActionIconProps {
  type: ExclusionTypeRaw;
}

export default ActionIcon;
